import React from 'react';

export const NewCommerce = React.lazy(() => import('./NewCommerce'));
export const EditCommerce = React.lazy(() => import('./EditCommerce'));
export const CommerceSettingsList = React.lazy(
  () => import('./CommerceSettingsList')
);
export const NewCommerceSettings = React.lazy(
  () => import('./NewCommerceSettings')
);
export const EditCommerceSettings = React.lazy(
  () => import('./EditCommerceSettings')
);
export const CommerceBranches = React.lazy(() => import('./CommerceBranches'));
export const NewBranch = React.lazy(() => import('./NewBranch'));
export const EditBranch = React.lazy(() => import('./EditBranch'));
export const BranchSettings = React.lazy(() => import('./BranchSettings'));
export const NewBranchSetting = React.lazy(() => import('./NewBranchSetting'));
export const EditBranchSetting = React.lazy(
  () => import('./EditBranchSetting')
);
export const IncludedPickupCommerces = React.lazy(
  () => import('./IncludedPickupCommerces/IncludedPickupCommerces')
);
export const CommerceIntegrationWizard = React.lazy(
  () => import('./CommerceIntegration/CommerceIntegrationWizard')
);
